module.exports = __webpack_public_path__ + "img/kriz.f7bfa541.svg";